(function () {
  var root = document.querySelector('[data-hs-training-today]');
  if (!root) return;

  var API = 'https://cxnxfkaxlgisnxudpjgn.supabase.co/functions/v1/boulevard-booking-proxy';
  var bookingUrl = root.getAttribute('data-booking-url') || '/#book-now';
  var servicesWrap = root.querySelector('[data-services]');
  var status = root.querySelector('[data-status]');
  var empty = root.querySelector('[data-empty]');
  var refresh = root.querySelector('[data-refresh]');
  var dateEyebrow = root.querySelector('[data-date-eyebrow]');
  var todayHeading = root.querySelector('[data-today-heading]');
  var todaySummary = root.querySelector('[data-today-summary]');
  var emptyTitle = root.querySelector('[data-empty-title]');
  var emptyCopy = root.querySelector('[data-empty-copy]');
  var runId = 0;

  function clean(value) { return String(value == null ? '' : value).trim(); }
  function salonToday() {
    var values = {};
    new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date()).forEach(function (part) { values[part.type] = part.value; });
    return values.year + '-' + values.month + '-' + values.day;
  }
  function displayToday(value) {
    return new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', weekday: 'long', month: 'long', day: 'numeric' }).format(new Date(value + 'T12:00:00-04:00'));
  }
  function nextSalonDate(value) {
    var parts = value.split('-').map(Number);
    var date = new Date(Date.UTC(parts[0], parts[1] - 1, parts[2] + 1, 12));
    return date.getUTCFullYear() + '-' + String(date.getUTCMonth() + 1).padStart(2, '0') + '-' + String(date.getUTCDate()).padStart(2, '0');
  }
  function timeLabel(slot) {
    var start = clean(slot && slot.start_at);
    if (start) {
      var date = new Date(start);
      if (!Number.isNaN(date.getTime())) return new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', hour: 'numeric', minute: '2-digit' }).format(date);
    }
    var label = clean(slot && slot.label);
    return label.split(',').pop().trim() || label;
  }
  function rangeTimeLabel(slot) {
    var end = clean(slot && slot.range_end_at);
    if (!end) return timeLabel(slot);
    var startDate = new Date(clean(slot.start_at)); var endDate = new Date(end);
    if (Number.isNaN(startDate.getTime()) || Number.isNaN(endDate.getTime())) return timeLabel(slot);
    var startParts = new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', hour: 'numeric', minute: '2-digit' }).format(startDate);
    var endParts = new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', hour: 'numeric', minute: '2-digit' }).format(endDate);
    var startMeridiem = (startParts.match(/\s(AM|PM)$/i) || [])[1]; var endMeridiem = (endParts.match(/\s(AM|PM)$/i) || [])[1];
    if (startMeridiem && startMeridiem === endMeridiem) startParts = startParts.replace(/\s(AM|PM)$/i, '');
    return startParts + '–' + endParts;
  }
  function openingTimeLabel(slot) {
    var times = Array.isArray(slot && slot.range_times) ? slot.range_times : [];
    if (times.length < 2) return timeLabel(slot);
    if (slot.range_consecutive) return rangeTimeLabel(slot);
    return times.map(function (start) { return timeLabel({ start_at: start }); }).join(' • ');
  }
  function customBookingUrl(definition, slot) {
    var assignment = serviceAssignment(slot, definition.id);
    var params = new URLSearchParams();
    params.set('last_minute', '1');
    params.set('service_id', definition.id);
    params.set('service_name', definition.title.replace(/^hs\./i, ''));
    params.set('date', clean(slot.booking_date));
    params.set('staff_id', clean(assignment.staff_variant_id) || clean(assignment.staff_id));
    if (definition.option_ids.length) params.set('option_ids', definition.option_ids.join(','));
    return '/pages/stylistsintraining?' + params.toString() + '#nextChapterBooking';
  }
  function initials(name) {
    if (/available stylist|stylist confirmed during booking/i.test(clean(name))) return 'HS';
    return clean(name).split(/\s+/).filter(Boolean).slice(0, 2).map(function (part) { return part.charAt(0).toUpperCase(); }).join('') || 'HS';
  }
  function api(payload) {
    return fetch(API, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) }).then(function (response) {
      return response.json().catch(function () { return null; }).then(function (data) {
        if (!response.ok || !data || !data.ok) throw new Error(data && data.error || 'Availability could not be loaded.');
        return data;
      });
    });
  }
  function publicServices(catalog) {
    return (Array.isArray(catalog && catalog.services) ? catalog.services : []).filter(function (service) {
      var name = clean(service && service.name);
      var included = /^(?:hs\.)?(?:Classic|Signature) Blowdry$/i.test(name) ||
        /^Women's Haircut(?: \(Pixie\/Short\))?$/i.test(name) ||
        /^Men's Haircut$/i.test(name) ||
        /^(?:Face Frame|Partial|Full Head) Dimensional Color Service$/i.test(name) ||
        /^Single Process Touchup$/i.test(name) ||
        /^Glaze\/Gloss$/i.test(name);
      return /^urn:blvd:Service:/i.test(clean(service && service.id)) && included && !/stylist in training/i.test(name);
    }).map(function (service, index) {
      var category = clean(service.category) || 'Services';
      return { key: clean(service.id).split(':').pop(), id: clean(service.id), title: clean(service.name), category: category, color: /going darker|covering gray|going lighter|highlights/i.test(category), order: index, option_ids: [] };
    });
  }
  function applyDefaultOptions(definitions, optionData) {
    var byId = {};
    (Array.isArray(optionData && optionData.services) ? optionData.services : []).forEach(function (service) {
      byId[clean(service.service_id)] = (Array.isArray(service.option_groups) ? service.option_groups : []).reduce(function (ids, group) {
        if (Number(group && group.min_limit) > 0 && Array.isArray(group.options) && group.options[0] && clean(group.options[0].id)) ids.push(clean(group.options[0].id));
        return ids;
      }, []);
    });
    definitions.forEach(function (definition) { definition.option_ids = byId[definition.id] || []; });
  }
  function requestedService(definition) { return { service_id: definition.id, option_ids: definition.option_ids || [] }; }
  function availability(services, date, datesOnly) {
    return api({ action: 'availability', services: services, date: date, dates_only: !!datesOnly, include_slot_breakout: !datesOnly }).then(function (data) {
      if (datesOnly) return (Array.isArray(data.dates) ? data.dates : []).indexOf(date) !== -1;
      var group = (Array.isArray(data.date_groups) ? data.date_groups : []).find(function (item) { return clean(item.date) === date; });
      return group && Array.isArray(group.slots) ? group.slots : [];
    });
  }
  function serviceAssignment(slot, serviceId) {
    var breakout = Array.isArray(slot && slot.service_breakout) ? slot.service_breakout : [];
    return breakout.find(function (item) { return clean(item && item.service_id) === clean(serviceId); }) || breakout[0] || {};
  }
  function openingKey(slot, serviceId) {
    var assignment = serviceAssignment(slot, serviceId);
    var staff = clean(assignment.staff_id) || clean(assignment.staff_name).toLowerCase();
    return [clean(slot && slot.start_at) || clean(slot && slot.label), staff].join('|');
  }
  function addonFromSlot(slot, colorId, fallbackLabel) {
    var breakout = Array.isArray(slot && slot.service_breakout) ? slot.service_breakout : [];
    var finish = breakout.find(function (item) { return clean(item && item.service_id) !== clean(colorId); }) || {};
    return { service_name: clean(finish.service_name) || fallbackLabel };
  }
  function loadColorAvailability(definition, classic, haircut, date) {
    var baseRequest = availability([requestedService(definition)], date, false);
    var addonRequests = [];
    if (classic) addonRequests.push({ label: 'Classic Blowdry', promise: availability([requestedService(definition), requestedService(classic)], date, false) });
    if (haircut) addonRequests.push({ label: "Women's Haircut", promise: availability([requestedService(definition), requestedService(haircut)], date, false) });
    return Promise.all([baseRequest].concat(addonRequests.map(function (request) { return request.promise.catch(function () { return []; }); }))).then(function (results) {
      var addonsByOpening = {};
      addonRequests.forEach(function (request, index) {
        results[index + 1].forEach(function (slot) {
          var key = openingKey(slot, definition.id);
          if (!addonsByOpening[key]) addonsByOpening[key] = [];
          var addon = addonFromSlot(slot, definition.id, request.label);
          if (!addonsByOpening[key].some(function (existing) { return clean(existing.service_name) === clean(addon.service_name); })) addonsByOpening[key].push(addon);
        });
      });
      return results[0].map(function (slot) { return Object.assign({}, slot, { addons: addonsByOpening[openingKey(slot, definition.id)] || [] }); });
    });
  }
  function runWorkers(items, count, handler) {
    var queue = items.slice();
    function worker() { var item = queue.shift(); if (!item) return Promise.resolve(); return Promise.resolve(handler(item)).then(worker); }
    return Promise.all(Array.from({ length: Math.min(count, Math.max(1, items.length)) }, worker));
  }
  function portrait(name, avatar) {
    var wrap = document.createElement('div'); wrap.className = 'hs-training-today__portrait';
    if (clean(avatar) && !/default-avatar\.png/i.test(avatar)) {
      var image = document.createElement('img'); image.src = clean(avatar); image.alt = clean(name); image.loading = 'lazy';
      image.addEventListener('error', function () { image.remove(); wrap.textContent = initials(name); }, { once: true }); wrap.appendChild(image);
    } else wrap.textContent = initials(name);
    return wrap;
  }
  function staffRow(item) {
    var name = clean(item && item.staff_name) || 'Stylist confirmed during booking';
    var stylist = document.createElement('div'); stylist.className = 'hs-training-today__stylist'; stylist.appendChild(portrait(name, item && item.staff_avatar));
    var copy = document.createElement('div'); copy.className = 'hs-training-today__stylist-copy';
    var service = document.createElement('strong'); service.textContent = clean(item && item.service_name) || 'Service';
    var stylistName = document.createElement('span'); stylistName.textContent = name;
    copy.appendChild(service); copy.appendChild(stylistName); stylist.appendChild(copy); return stylist;
  }
  function slotCard(definition, slot) {
    var breakout = Array.isArray(slot.service_breakout) ? slot.service_breakout : [];
    var addons = Array.isArray(slot.addons) ? slot.addons : [];
    var article = document.createElement('article'); article.className = 'hs-training-today__slot';
    var top = document.createElement('div'); top.className = 'hs-training-today__slot-top';
    var time = document.createElement('strong'); time.className = 'hs-training-today__slot-time'; time.textContent = openingTimeLabel(slot); top.appendChild(time);
    var badge = document.createElement('span'); badge.className = 'hs-training-today__badge'; badge.textContent = Number(slot.range_count) > 1 ? slot.range_count + ' start times' : (addons.length ? 'Finish available' : 'Available today'); top.appendChild(badge); article.appendChild(top);
    var team = document.createElement('div'); team.className = 'hs-training-today__team';
    if (breakout.length) breakout.forEach(function (item) { team.appendChild(staffRow(item)); }); else team.appendChild(staffRow({ service_name: definition.title }));
    article.appendChild(team);
    if (addons.length) {
      var addonWrap = document.createElement('div'); addonWrap.className = 'hs-training-today__addons';
      var addonTitle = document.createElement('strong'); addonTitle.textContent = 'You can add'; addonWrap.appendChild(addonTitle);
      addons.forEach(function (addon) {
        var option = document.createElement('span'); var label = clean(addon.service_name).replace(/^hs\./i, '');
        option.textContent = label + (addon.select_times ? ' on select times' : ''); addonWrap.appendChild(option);
      });
      article.appendChild(addonWrap);
    }
    var link = document.createElement('a'); link.className = 'hs-training-today__slot-link'; link.href = customBookingUrl(definition, slot); link.textContent = 'Book now';
    article.appendChild(link); return article;
  }
  function groupMeta(definition) {
    if (/Dimensional Color Service$/i.test(definition.title)) return { key: 'dimensional', title: 'Dimensional Color', order: 0 };
    if (/Haircut/i.test(definition.title)) return { key: 'haircuts', title: 'Haircuts', order: 1 };
    if (/Blowdry/i.test(definition.title)) return { key: 'blowdries', title: 'Blowdries', order: 2 };
    return { key: 'single-glaze', title: 'Single Process & Glazes', order: 3 };
  }
  function openingPriority(opening) {
    var name = opening.definition.title;
    if (/Full Head Dimensional/i.test(name)) return 40;
    if (/Partial Dimensional/i.test(name)) return 35;
    if (/Face Frame Dimensional/i.test(name)) return 30;
    if (/Signature Blowdry/i.test(name)) return 25;
    if (/Classic Blowdry/i.test(name)) return 20;
    if (/^Women's Haircut$/i.test(name)) return 18;
    if (/Pixie\/Short/i.test(name)) return 17;
    if (/Men's Haircut/i.test(name)) return 16;
    if (/Single Process/i.test(name)) return 15;
    if (/Glaze\/Gloss/i.test(name)) return 14;
    return 0;
  }
  function dedupeGroupOpenings(openings) {
    var unique = {};
    openings.forEach(function (opening) {
      var assignment = serviceAssignment(opening.slot, opening.definition.id);
      var staff = clean(assignment.staff_id) || clean(assignment.staff_name).toLowerCase() || 'unassigned:' + clean(opening.slot.id);
      var key = [clean(opening.slot.start_at) || clean(opening.slot.label), staff].join('|');
      if (!unique[key] || openingPriority(opening) > openingPriority(unique[key])) unique[key] = opening;
    });
    return Object.keys(unique).map(function (key) { return unique[key]; });
  }
  function aggregateOpeningRanges(openings) {
    var buckets = {};
    openings.forEach(function (opening) {
      var assignment = serviceAssignment(opening.slot, opening.definition.id);
      var staff = clean(assignment.staff_id) || clean(assignment.staff_name).toLowerCase() || 'unassigned:' + clean(opening.slot.id);
      var key = [opening.definition.id, staff].join('|');
      if (!buckets[key]) buckets[key] = [];
      buckets[key].push(opening);
    });
    var ranges = [];
    Object.keys(buckets).forEach(function (key) {
      var bucket = buckets[key].sort(function (a, b) { return clean(a.slot.start_at).localeCompare(clean(b.slot.start_at)); });
      var first = bucket[0]; var addonCounts = {};
      bucket.forEach(function (opening) {
        (Array.isArray(opening.slot.addons) ? opening.slot.addons : []).forEach(function (addon) {
          var name = clean(addon.service_name); if (name) addonCounts[name] = Number(addonCounts[name] || 0) + 1;
        });
      });
      var combined = { definition: first.definition, slot: Object.assign({}, first.slot, {
        range_end_at: bucket.length > 1 ? bucket[bucket.length - 1].slot.start_at : null,
        range_count: bucket.length,
        range_times: bucket.map(function (opening) { return opening.slot.start_at; }),
        range_consecutive: bucket.length > 1 && bucket.every(function (opening, index) {
          if (!index) return true;
          var previous = new Date(bucket[index - 1].slot.start_at).getTime();
          var current = new Date(opening.slot.start_at).getTime();
          return Number.isFinite(previous) && Number.isFinite(current) && current > previous && current - previous <= 30 * 60 * 1000;
        }),
        addons: Object.keys(addonCounts).map(function (name) { return { service_name: name, select_times: addonCounts[name] < bucket.length }; })
      }) };
      ranges.push(combined);
    });
    return ranges;
  }
  function renderGroups(results) {
    var groups = {}; var renderedCount = 0;
    results.forEach(function (result) {
      if (!result.slots.length) return;
      var meta = groupMeta(result.definition);
      if (!groups[meta.key]) groups[meta.key] = { meta: meta, openings: [] };
      result.slots.forEach(function (slot) { groups[meta.key].openings.push({ definition: result.definition, slot: slot }); });
    });
    servicesWrap.replaceChildren();
    Object.keys(groups).map(function (key) { return groups[key]; }).sort(function (a, b) { return a.meta.order - b.meta.order; }).forEach(function (group) {
      group.openings = aggregateOpeningRanges(dedupeGroupOpenings(group.openings)).sort(function (a, b) { return clean(a.slot.start_at).localeCompare(clean(b.slot.start_at)) || a.definition.order - b.definition.order; });
      renderedCount += group.openings.length;
      var section = document.createElement('section'); section.className = 'hs-training-today__service'; section.setAttribute('data-group', group.meta.key);
      var header = document.createElement('header'); header.className = 'hs-training-today__service-header'; var titleWrap = document.createElement('div');
      var category = document.createElement('small'); category.textContent = 'Featured openings';
      var heading = document.createElement('h3'); heading.textContent = group.meta.title; titleWrap.appendChild(category); titleWrap.appendChild(heading);
      var count = document.createElement('span'); count.textContent = 'Limited availability'; header.appendChild(titleWrap); header.appendChild(count); section.appendChild(header);
      var list = document.createElement('div'); list.className = 'hs-training-today__slots';
      group.openings.forEach(function (opening, index) { var card = slotCard(opening.definition, opening.slot); if (index >= 3) { card.hidden = true; card.classList.add('is-extra'); } list.appendChild(card); });
      section.appendChild(list);
      if (group.openings.length > 3) {
        var more = document.createElement('button'); more.type = 'button'; more.className = 'hs-training-today__more'; more.textContent = 'Show more times'; more.setAttribute('aria-expanded', 'false');
        more.addEventListener('click', function () {
          var expanded = more.getAttribute('aria-expanded') === 'true';
          Array.prototype.forEach.call(list.querySelectorAll('.is-extra'), function (card) { card.hidden = !expanded ? false : true; });
          more.setAttribute('aria-expanded', expanded ? 'false' : 'true'); more.textContent = expanded ? 'Show more times' : 'Show fewer times';
        });
        section.appendChild(more);
      }
      servicesWrap.appendChild(section);
    });
    return renderedCount;
  }
  function renderLoading() {
    servicesWrap.replaceChildren(); var loading = document.createElement('div'); loading.className = 'hs-training-today__loading'; loading.setAttribute('aria-label', 'Loading appointments');
    for (var i = 0; i < 3; i += 1) loading.appendChild(document.createElement('span')); servicesWrap.appendChild(loading);
  }
  function loadDate(definitions, classic, haircut, date, fallback, currentRun) {
    var available = []; var checked = 0; var openings = 0;
    dateEyebrow.textContent = fallback ? 'Available tomorrow' : 'Available today';
    todayHeading.textContent = displayToday(date);
    todaySummary.textContent = fallback ? 'No openings remain today. Showing a curated selection for tomorrow.' : 'A curated selection of same-day availability across the Hairstories team.';
    renderLoading();
    status.textContent = fallback ? 'Checking tomorrow’s openings…' : 'Checking today’s openings…';
    return runWorkers(definitions, 6, function (definition) {
      return availability([requestedService(definition)], date, true).then(function (hasOpenings) { if (hasOpenings) available.push(definition); }).catch(function () {}).then(function () {
        checked += 1; if (currentRun === runId) status.textContent = 'Checked ' + checked + ' of ' + definitions.length + ' services for ' + (fallback ? 'tomorrow' : 'today') + '…';
      });
    }).then(function () {
      if (currentRun !== runId) return 0;
      servicesWrap.replaceChildren(); available.sort(function (a, b) { return a.order - b.order; }); if (!available.length) return 0;
      var loaded = 0; var loadedResults = []; status.textContent = 'Loading stylist details for ' + available.length + (available.length === 1 ? ' service…' : ' services…');
      return runWorkers(available, 6, function (definition) {
        var slotsRequest = definition.color ? loadColorAvailability(definition, classic, haircut, date) : availability([requestedService(definition)], date, false);
        return slotsRequest.then(function (slots) { if (currentRun !== runId) return; slots.forEach(function (slot) { slot.booking_date = date; }); loadedResults.push({ definition: definition, slots: slots }); openings = renderGroups(loadedResults); }).catch(function () {}).then(function () {
          loaded += 1; if (currentRun === runId) status.textContent = loaded < available.length ? 'Loaded ' + loaded + ' of ' + available.length + ' available services…' : '';
        });
      }).then(function () { return openings; });
    });
  }
  function loadToday() {
    runId += 1; var currentRun = runId; var today = salonToday();
    refresh.disabled = true; empty.hidden = true; status.className = 'hs-training-today__status'; status.textContent = 'Loading the service menu…';
    return api({ action: 'catalog' }).then(function (catalog) {
      var definitions = publicServices(catalog); if (!definitions.length) throw new Error('No public services are available.');
      return api({ action: 'service-options', services: definitions.map(function (definition) { return { service_id: definition.id }; }) }).catch(function () { return { services: [] }; }).then(function (options) {
        applyDefaultOptions(definitions, options);
        var classic = definitions.find(function (definition) { return definition.title === 'hs.Classic Blowdry'; }) || null;
        var haircut = definitions.find(function (definition) { return definition.title === "Women's Haircut"; }) || null;
        return loadDate(definitions, classic, haircut, today, false, currentRun).then(function (todayOpenings) {
          if (currentRun !== runId || todayOpenings) return { openings: todayOpenings, fallback: false };
          return loadDate(definitions, classic, haircut, nextSalonDate(today), true, currentRun).then(function (tomorrowOpenings) { return { openings: tomorrowOpenings, fallback: true }; });
        });
      });
    }).then(function (result) {
      if (currentRun !== runId || !result) return;
      refresh.disabled = false;
      status.textContent = result.openings ? 'Limited last-minute availability ' + (result.fallback ? 'tomorrow.' : 'today.') : '';
      empty.hidden = result.openings !== 0;
      if (!result.openings) {
        servicesWrap.replaceChildren(); emptyTitle.textContent = 'No last-minute openings found for today or tomorrow.'; emptyCopy.textContent = 'New appointments can open up throughout the day. Refresh this page or explore upcoming dates.';
      }
    }).catch(function () {
      if (currentRun !== runId) return; refresh.disabled = false; status.className = 'hs-training-today__status is-error'; status.textContent = 'Availability could not be loaded. Please refresh and try again.';
    });
  }

  refresh.addEventListener('click', loadToday); loadToday();
})();
